import { Injectable } from '@angular/core';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { Device } from '@capacitor/device';
import { Capacitor } from '@capacitor/core';

@Injectable({
    providedIn: 'root'
})
export class OrientationService {

    async setupOrientationForDevice(): Promise<void> {
        if (!Capacitor.isNativePlatform()) return;

        try {
            const deviceInfo = await Device.getInfo();
            const isTablet = await this.isTabletDevice();

            if (isTablet) {
                // Tablets: permitir landscape
                await ScreenOrientation.lock({ orientation: 'landscape' });
                console.log('Orientación configurada para tablet: landscape');
            } else {
                // Móviles: forzar portrait
                await ScreenOrientation.lock({ orientation: 'portrait' });
                console.log('Orientación configurada para móvil: portrait');
            }
        } catch (error) {
            console.error('Error configurando orientación:', error);
        }
    }

    private async isTabletDevice(): Promise<boolean> {
        try {
            const deviceInfo = await Device.getInfo();

            // Para Android
            if (deviceInfo.platform === 'android') {
                // Verificar tamaño de pantalla usando JavaScript
                const screenWidth = window.screen.width;
                const screenHeight = window.screen.height;
                const maxDimension = Math.max(screenWidth, screenHeight);
                const minDimension = Math.min(screenWidth, screenHeight);

                // Considerar tablet si la dimensión menor es >= 600px
                return minDimension >= 600;
            }

            // Para iOS
            if (deviceInfo.platform === 'ios') {
                const model = deviceInfo.model.toLowerCase();
                return model.includes('ipad');
            }

            return false;
        } catch (error) {
            console.error('Error detectando tipo de dispositivo:', error);
            return false;
        }
    }

    async unlockOrientation(): Promise<void> {
        if (!Capacitor.isNativePlatform()) return;

        try {
            await ScreenOrientation.unlock();
            console.log('Orientación desbloqueada');
        } catch (error) {
            console.error('Error desbloqueando orientación:', error);
        }
    }
}